import React from "react";
import {observer} from "mobx-react";
import {FlightsDatesSelector} from "../../services/flight-search/dates-selection/flights-dates-selector";
import {MonthModel} from "../../services/time/month.model";
import {CalendarComponent} from "../calendar/calendar.component";
import {FlightCalendarDayComponent} from "./flight-calendar-day.component";

interface FlightOneMonthScheduleComponentProps {
    flightsDatesSelector: FlightsDatesSelector;
    month: MonthModel;
    onDateClicked: (date: Date) => void;
}

export const FlightCalendarMonthComponent: React.FC<FlightOneMonthScheduleComponentProps> = observer((props) => {
    const m = props.month;

    const renderDate = (date: Date, isInViewPort: boolean) => {
        return (
            <FlightCalendarDayComponent date={date}
                                        shouldRenderPrice={isInViewPort}
                                        flightsDatesSelector={props.flightsDatesSelector}/>
        );
    };

    return (
        <CalendarComponent key={m.key}
                           month={m.month}
                           year={m.year}
                           renderDate={(date, isInViewPort) => renderDate(date, isInViewPort)}
                           onClick={props.onDateClicked}/>
    );
});
